/*!
 * p5-address v3.1.8 
 * (c) 2021 Project Five
 * Released under the MIT License.
 */
import loadGoogleMapsAPI from 'load-google-maps-api';

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var script = {
  name: 'GMapsAddress',
  props: {
    editable: {
      type: Boolean,
      default: true
    },
    editableFields: {
      type: Array,
      default: function _default() {
        return ['street', 'number', 'zip', 'city', 'country'];
      } // also, place_id, coords

    },
    extraData: {
      type: Array,
      default: function _default() {
        return [];
      } // Supports 'timezone'

    },
    openAfterAdd: Boolean,
    readonly: Boolean,
    showOnMapButton: Boolean,
    requiredParts: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    translations: {
      // see defaultTranslations
      type: Object,
      default: function _default() {
        return {};
      }
    },
    required: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      localValue: {},
      invalid: [],
      searchBox: null,
      showFields: false,
      strings: {},
      defaultTranslations: {
        street: 'Straat',
        number: 'Nummer',
        zip: 'Postcode',
        city: 'Plaats',
        country: 'Land',
        lat: 'Latitude',
        lng: 'Langitude',
        timezone: 'Tijdzone',
        place_id: 'Google Maps Place ID',
        hasInvalid: 'Nog niet alle verplichten velden zijn ingevuld'
      },
      timezoneAPIKey: 'AIzaSyBxfJBiicFWST6xGvZdkC4HdW-dOccbprg'
    };
  },
  mounted: function mounted() {
    this.$loadGoogleMaps(this.init);
  },
  methods: {
    init: function init(google) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (google.maps) {
        google = google.maps;
      }

      if (!this.readonly) {
        this.searchBox = new google.places.Autocomplete(this.$refs.input, options);
        this.searchBox.addListener('place_changed', this.changed);
        this.disableAutofill();
      }
    },
    disableAutofill: function disableAutofill() {
      var autocompleteInput = this.$refs.input;
      var observerHack = new MutationObserver(function () {
        observerHack.disconnect();
        autocompleteInput.setAttribute('autocomplete', 'new-password');
      });
      observerHack.observe(autocompleteInput, {
        attributes: true,
        attributeFilter: ['autocomplete']
      });
    },
    changed: function changed() {
      var _this = this;

      var place = this.searchBox.getPlace();

      if (!place.geometry) {
        this.onBlur(0);
        return;
      }

      try {
        if (!place.address_components) {
          throw new Error('incomplete data');
        }

        var comps = place.address_components;
        var number_obj = comps.find(function (it) {
          return it.types.includes('street_number');
        }) || {};
        var street_obj = comps.find(function (it) {
          return it.types.includes('route');
        }) || {};
        var zip_obj = comps.find(function (it) {
          return it.types.includes('postal_code');
        }) || {};
        var city_obj = comps.find(function (it) {
          return it.types.includes('locality') || it.types.includes('postal_town');
        }) || {};
        var country_obj = comps.find(function (it) {
          return it.types.includes('country');
        }) || {};
        var address = {
          formatted: place.formatted_address,
          parts: {
            number: number_obj.long_name || '',
            street: street_obj.long_name || '',
            zip: zip_obj.long_name || '',
            city: city_obj.long_name || '',
            country: country_obj.long_name || '',
            country_code: country_obj.short_name || ''
          },
          coords: {
            lat: place.geometry.location.lat(),
            lng: place.geometry.location.lng()
          }
        };

        if (this.extraData.includes('timezone')) {
          address.timezone = undefined;
        }

        if (place.place_id) {
          address.place_id = place.place_id;
        }

        this.localValue = address;
        this.validateParts();

        if (this.invalid.length) {
          if (this.editable) {
            this.showFields = true;

            if (this.invalid.length === 1 && this.invalid[0] === 'timezone') {
              this.processChange(address);
            }
          } else {
            throw new Error("missing: ".concat(this.invalid.join(', ')));
          }
        } else {
          if (this.openAfterAdd && this.editable) {
            this.showFields = true;
          }

          this.processChange(address).then(function () {
            _this.$emit('input', _this.localValue);
          });
        }
      } catch (err) {
        this.$emit('error', err.message);
        this.$emit('input', {});
      }
    },
    processChange: function processChange(address) {
      var _this2 = this;

      return new Promise(function (resolve) {
        var promises = [];
        var promiseTypes = [];

        if (_this2.extraData.length) {
          _this2.extraData.forEach(function (extra) {
            if (extra === 'timezone') {
              promiseTypes.push('timezone');
              promises.push(_this2.fetchTimezone(_objectSpread2({}, address.coords)));
            }
          });
        }

        return Promise.all(promises).then(function (r) {
          promiseTypes.forEach(function (type, index) {
            if (type === 'timezone') {
              address.timezone = typeof r[index] === 'string' ? r[index] : undefined;
            }
          });
        }).then(resolve);
      });
    },
    fetchTimezone: function fetchTimezone(_ref) {
      var _this3 = this;

      var lat = _ref.lat,
          lng = _ref.lng;
      return new Promise(function (resolve, reject) {
        fetch("https://maps.googleapis.com/maps/api/timezone/json?location=".concat(lat, ",").concat(lng, "&key=").concat(_this3.timezoneAPIKey, "&timestamp=").concat(Math.floor(Date.now() / 1000))).then(function (r) {
          return r.json();
        }).then(function (r) {
          if (r.status === 'OK') {
            resolve(r.timeZoneId);
          } else {
            throw new Error('Invalid timezone data received');
          }
        }).catch(reject);
      });
    },
    onBlur: function onBlur() {
      var _this4 = this;

      var timeout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 250;

      if (!this.$attrs.readonly) {
        setTimeout(function () {
          if (_this4.$refs.input.value === '') {
            _this4.$emit('input', {});
          } else {
            _this4.$refs.input.value = _this4.localValue && _this4.localValue.formatted ? _this4.localValue.formatted : '';
          }
        }, timeout);
      }
    },
    onManualUpdate: function onManualUpdate() {
      var _this5 = this;

      this.validateParts();
      this.localValue.formatted = "".concat(this.localValue.parts.street, " ").concat(this.localValue.parts.number, ", ").concat(this.localValue.parts.zip, " ").concat(this.localValue.parts.city, ", ").concat(this.localValue.parts.country);

      if (!this.invalid.length || this.invalid.length === 1 && this.invalid[0] === 'timezone') {
        this.processChange(this.localValue).then(function () {
          _this5.$emit('input', _this5.localValue);
        });
      }
    },
    onManualTimezoneSelect: function onManualTimezoneSelect(ev) {
      this.localValue.timezone = ev.target.value;
      ev.target.blur();

      if (this.localValue.timezone && !this.$options.timezones.includes(this.localValue.timezone)) {
        this.localValue.timezone = undefined;
      }

      this.onManualUpdate();
    },
    setTranslations: function setTranslations() {
      this.strings = Object.assign({}, this.defaultTranslations, this.translations);
    },
    validateParts: function validateParts() {
      var _this6 = this;

      if (!this.$attrs.readonly) {
        this.invalid = this.requiredParts.filter(function (part) {
          switch (part) {
            case 'place_id':
              if (!_this6.localValue.place_id) {
                return true;
              }

              return false;

            case 'coords':
              if (!_this6.localValue.coords || !_this6.localValue.coords.lat || !_this6.localValue.coords.lng) {
                return true;
              }

              return false;

            case 'timezone':
              if (!_this6.localValue.timezone) {
                return true;
              }

              return false;

            default:
              if (_this6.localValue.formatted && (!_this6.localValue.parts || !_this6.localValue.parts[part])) {
                return true;
              }

              return false;
          }
        });

        if (this.invalid.length && this.editable && !this.readonly) {
          this.showFields = true;
        }
      }
    }
  },
  watch: {
    value: {
      handler: function handler(val) {
        this.localValue = JSON.parse(JSON.stringify(val));
        this.validateParts();
      },
      immediate: true
    },
    translations: {
      handler: 'setTranslations',
      immediate: true,
      deep: true
    }
  },
  timezones: ['Africa/Abidjan', 'Africa/Accra', 'Africa/Algiers', 'Africa/Bissau', 'Africa/Cairo', 'Africa/Casablanca', 'Africa/Ceuta', 'Africa/El_Aaiun', 'Africa/Johannesburg', 'Africa/Khartoum', 'Africa/Lagos', 'Africa/Maputo', 'Africa/Monrovia', 'Africa/Nairobi', 'Africa/Ndjamena', 'Africa/Tripoli', 'Africa/Tunis', 'Africa/Windhoek', 'America/Anchorage', 'America/Araguaina', 'America/Argentina/Buenos_Aires', 'America/Asuncion', 'America/Bahia', 'America/Barbados', 'America/Belem', 'America/Belize', 'America/Boa_Vista', 'America/Bogota', 'America/Campo_Grande', 'America/Cancun', 'America/Caracas', 'America/Cayenne', 'America/Cayman', 'America/Chicago', 'America/Costa_Rica', 'America/Cuiaba', 'America/Curacao', 'America/Danmarkshavn', 'America/Dawson_Creek', 'America/Denver', 'America/Edmonton', 'America/El_Salvador', 'America/Fortaleza', 'America/Godthab', 'America/Grand_Turk', 'America/Guatemala', 'America/Guayaquil', 'America/Guyana', 'America/Halifax', 'America/Havana', 'America/Hermosillo', 'America/Iqaluit', 'America/Jamaica', 'America/La_Paz', 'America/Lima', 'America/Los_Angeles', 'America/Maceio', 'America/Managua', 'America/Manaus', 'America/Martinique', 'America/Mazatlan', 'America/Mexico_City', 'America/Miquelon', 'America/Montevideo', 'America/Nassau', 'America/New_York', 'America/Noronha', 'America/Panama', 'America/Paramaribo', 'America/Phoenix', 'America/Port-au-Prince', 'America/Port_of_Spain', 'America/Porto_Velho', 'America/Puerto_Rico', 'America/Recife', 'America/Regina', 'America/Rio_Branco', 'America/Santiago', 'America/Santo_Domingo', 'America/Sao_Paulo', 'America/Scoresbysund', 'America/St_Johns', 'America/Tegucigalpa', 'America/Thule', 'America/Tijuana', 'America/Toronto', 'America/Vancouver', 'America/Whitehorse', 'America/Winnipeg', 'America/Yellowknife', 'Antarctica/Casey', 'Antarctica/Davis', 'Antarctica/DumontDUrville', 'Antarctica/Mawson', 'Antarctica/Palmer', 'Antarctica/Rothera', 'Antarctica/Syowa', 'Antarctica/Vostok', 'Asia/Almaty', 'Asia/Amman', 'Asia/Aqtau', 'Asia/Aqtobe', 'Asia/Ashgabat', 'Asia/Baghdad', 'Asia/Baku', 'Asia/Bangkok', 'Asia/Beirut', 'Asia/Bishkek', 'Asia/Brunei', 'Asia/Calcutta', 'Asia/Choibalsan', 'Asia/Colombo', 'Asia/Damascus', 'Asia/Dhaka', 'Asia/Dili', 'Asia/Dubai', 'Asia/Dushanbe', 'Asia/Gaza', 'Asia/Ho_Chi_Minh', 'Asia/Hong_Kong', 'Asia/Hovd', 'Asia/Irkutsk', 'Asia/Jakarta', 'Asia/Jayapura', 'Asia/Jerusalem', 'Asia/Kabul', 'Asia/Kamchatka', 'Asia/Karachi', 'Asia/Katmandu', 'Asia/Krasnoyarsk', 'Asia/Kuala_Lumpur', 'Asia/Macau', 'Asia/Magadan', 'Asia/Makassar', 'Asia/Manila', 'Asia/Nicosia', 'Asia/Omsk', 'Asia/Pyongyang', 'Asia/Qatar', 'Asia/Rangoon', 'Asia/Riyadh', 'Asia/Saigon', 'Asia/Seoul', 'Asia/Shanghai', 'Asia/Singapore', 'Asia/Taipei', 'Asia/Tashkent', 'Asia/Tbilisi', 'Asia/Tehran', 'Asia/Thimphu', 'Asia/Tokyo', 'Asia/Ulaanbaatar', 'Asia/Vladivostok', 'Asia/Yakutsk', 'Asia/Yekaterinburg', 'Asia/Yerevan', 'Atlantic/Azores', 'Atlantic/Bermuda', 'Atlantic/Canary', 'Atlantic/Cape_Verde', 'Atlantic/Faroe', 'Atlantic/Reykjavik', 'Atlantic/South_Georgia', 'Atlantic/Stanley', 'Australia/Adelaide', 'Australia/Brisbane', 'Australia/Darwin', 'Australia/Hobart', 'Australia/Perth', 'Australia/Sydney', 'Etc/GMT', 'Europe/Amsterdam', 'Europe/Andorra', 'Europe/Athens', 'Europe/Belgrade', 'Europe/Berlin', 'Europe/Brussels', 'Europe/Bucharest', 'Europe/Budapest', 'Europe/Chisinau', 'Europe/Copenhagen', 'Europe/Dublin', 'Europe/Gibraltar', 'Europe/Helsinki', 'Europe/Istanbul', 'Europe/Kaliningrad', 'Europe/Kiev', 'Europe/Lisbon', 'Europe/London', 'Europe/Luxembourg', 'Europe/Madrid', 'Europe/Malta', 'Europe/Minsk', 'Europe/Monaco', 'Europe/Moscow', 'Europe/Oslo', 'Europe/Paris', 'Europe/Prague', 'Europe/Riga', 'Europe/Rome', 'Europe/Samara', 'Europe/Sofia', 'Europe/Stockholm', 'Europe/Tallinn', 'Europe/Tirane', 'Europe/Vienna', 'Europe/Vilnius', 'Europe/Warsaw', 'Europe/Zurich', 'Indian/Chagos', 'Indian/Christmas', 'Indian/Cocos', 'Indian/Kerguelen', 'Indian/Mahe', 'Indian/Maldives', 'Indian/Mauritius', 'Indian/Reunion', 'Pacific/Apia', 'Pacific/Auckland', 'Pacific/Chuuk', 'Pacific/Easter', 'Pacific/Efate', 'Pacific/Enderbury', 'Pacific/Fakaofo', 'Pacific/Fiji', 'Pacific/Funafuti', 'Pacific/Galapagos', 'Pacific/Gambier', 'Pacific/Guadalcanal', 'Pacific/Guam', 'Pacific/Honolulu', 'Pacific/Kiritimati', 'Pacific/Kosrae', 'Pacific/Kwajalein', 'Pacific/Majuro', 'Pacific/Marquesas', 'Pacific/Nauru', 'Pacific/Niue', 'Pacific/Norfolk', 'Pacific/Noumea', 'Pacific/Pago_Pago', 'Pacific/Palau', 'Pacific/Pitcairn', 'Pacific/Pohnpei', 'Pacific/Port_Moresby', 'Pacific/Rarotonga', 'Pacific/Tahiti', 'Pacific/Tarawa', 'Pacific/Tongatapu', 'Pacific/Wake', 'Pacific/Wallis']
};

function normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD = document.head || document.getElementsByTagName('head')[0];
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);
      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p5address"},[_c('div',{staticClass:"p5address__autocomplete"},[_c('input',{ref:"input",class:{ '-is-invalid': _vm.invalid.length, 'opacity-50': _vm.showFields, 'hover:opacity-100': _vm.showFields },attrs:{"type":"text","placeholder":"","autocomplete":"new-password","required":_vm.required,"readonly":_vm.readonly},domProps:{"value":_vm.localValue.formatted || ''},on:{"blur":_vm.onBlur,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();}}}),_vm._v(" "),(_vm.required && _vm.invalid.length)?_c('input',{staticClass:"p5address__hidden-required",attrs:{"type":"text","required":""}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"p5address__actions"},[(_vm.localValue.parts && _vm.showOnMapButton)?_c('a',{attrs:{"href":'https://google.com/maps/search/?api=1&query=Collab%20' + _vm.localValue.parts.city + '&query_place_id=' + _vm.localValue.place_id,"rel":"nofollow noreferrer","target":"_blank"}},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20.5,3L20.34,3.03L15,5.1L9,3L3.36,4.9C3.15,4.97 3,5.15 3,5.38V20.5A0.5,0.5 0 0,0 3.5,21L3.66,20.97L9,18.9L15,21L20.64,19.1C20.85,19.03 21,18.85 21,18.62V3.5A0.5,0.5 0 0,0 20.5,3M10,5.47L14,6.87V18.53L10,17.13V5.47M5,6.46L8,5.45V17.15L5,18.31V6.46M19,17.54L16,18.55V6.86L19,5.7V17.54Z"}})])]):_vm._e(),_vm._v(" "),(_vm.localValue.parts && _vm.editable && !_vm.readonly)?_c('span',{class:{ '-is-open': _vm.showFields },on:{"click":function($event){_vm.showFields = !_vm.showFields;}}},[_c('svg',{attrs:{"viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M7.41,8.58L12,13.17L16.59,8.58L18,10L12,16L6,10L7.41,8.58Z"}})])]):_vm._e()])]),_vm._v(" "),(_vm.invalid.length && !_vm.readonly)?_c('div',{staticClass:"p5address__errors"},[_vm._v("\n        "+_vm._s(_vm.strings.hasInvalid)+"\n    ")]):_vm._e(),_vm._v(" "),(_vm.showFields && _vm.localValue.parts)?_c('div',{staticClass:"p5address__parts"},[_c('div',[(_vm.editableFields.includes('street'))?_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.street))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue.parts.street),expression:"localValue.parts.street"}],class:{ '-is-invalid': _vm.invalid.includes('street') },attrs:{"type":"text","autocomplete":"new-password"},domProps:{"value":(_vm.localValue.parts.street)},on:{"change":_vm.onManualUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localValue.parts, "street", $event.target.value);}}})]):_vm._e(),_vm._v(" "),(_vm.editableFields.includes('number'))?_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.number))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue.parts.number),expression:"localValue.parts.number"}],class:{ '-is-invalid': _vm.invalid.includes('number') },attrs:{"type":"text","autocomplete":"new-password"},domProps:{"value":(_vm.localValue.parts.number)},on:{"change":_vm.onManualUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localValue.parts, "number", $event.target.value);}}})]):_vm._e()]),_vm._v(" "),_c('div',[(_vm.editableFields.includes('zip'))?_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.zip))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue.parts.zip),expression:"localValue.parts.zip"}],class:{ '-is-invalid': _vm.invalid.includes('zip') },attrs:{"type":"text","autocomplete":"new-password"},domProps:{"value":(_vm.localValue.parts.zip)},on:{"change":_vm.onManualUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localValue.parts, "zip", $event.target.value);}}})]):_vm._e(),_vm._v(" "),(_vm.editableFields.includes('city'))?_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.city))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue.parts.city),expression:"localValue.parts.city"}],class:{ '-is-invalid': _vm.invalid.includes('city') },attrs:{"type":"text","autocomplete":"new-password"},domProps:{"value":(_vm.localValue.parts.city)},on:{"change":_vm.onManualUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localValue.parts, "city", $event.target.value);}}})]):_vm._e()]),_vm._v(" "),(_vm.editableFields.includes('country'))?_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.country))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue.parts.country),expression:"localValue.parts.country"}],class:{ '-is-invalid': _vm.invalid.includes('country') },attrs:{"type":"text","autocomplete":"new-password"},domProps:{"value":(_vm.localValue.parts.country)},on:{"change":_vm.onManualUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localValue.parts, "country", $event.target.value);}}})]):_vm._e(),_vm._v(" "),(_vm.editableFields.includes('coords'))?_c('div',[_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.lat))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue.coords.lat),expression:"localValue.coords.lat"}],class:{ '-is-invalid': _vm.invalid.includes('coords') && !_vm.localValue.coords.lat },attrs:{"type":"text","autocomplete":"new-password"},domProps:{"value":(_vm.localValue.coords.lat)},on:{"change":_vm.onManualUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localValue.coords, "lat", $event.target.value);}}})]),_vm._v(" "),_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.lng))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue.coords.lng),expression:"localValue.coords.lng"}],class:{ '-is-invalid': _vm.invalid.includes('coords') && !_vm.localValue.coords.lng },attrs:{"type":"text","autocomplete":"new-password"},domProps:{"value":(_vm.localValue.coords.lng)},on:{"change":_vm.onManualUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localValue.coords, "lng", $event.target.value);}}})])]):_vm._e(),_vm._v(" "),(_vm.editableFields.includes('place_id'))?_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.place_id))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.localValue.place_id),expression:"localValue.place_id"}],class:{ '-is-invalid': _vm.invalid.includes('place_id') },attrs:{"type":"text","autocomplete":"new-password"},domProps:{"value":(_vm.localValue.place_id)},on:{"change":_vm.onManualUpdate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.localValue, "place_id", $event.target.value);}}})]):_vm._e(),_vm._v(" "),(_vm.editableFields.includes('timezone'))?_c('fieldset',[_c('label',[_vm._v(_vm._s(_vm.strings.timezone))]),_vm._v(" "),_c('input',{class:{ '-is-invalid': _vm.invalid.includes('timezone') },attrs:{"list":"timezones","autocomplete":"off","id":"p5address__timezone"},domProps:{"value":_vm.localValue.timezone},on:{"change":_vm.onManualTimezoneSelect}}),_vm._v(" "),_c('datalist',{attrs:{"id":"timezones"}},_vm._l((_vm.$options.timezones),function(timezone){return _c('option',{key:'tz_' + timezone,domProps:{"value":timezone}})}),0)]):_vm._e()]):_vm._e()])};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-120735bc_0", { source: ".p5address{--default-p5address-danger-bg:#f5aabd;--default-p5address-primary:#212121;--default-p5address-secondary:#757575;--default-p5address-input-height:4rem;--default-p5address-margin:0.8rem}.p5address__autocomplete{position:relative}.p5address__autocomplete input{padding-right:7rem;height:var(--p5address-input-height,var(--default-p5address-input-height));line-height:var(--p5address-input-height,var(--default-p5address-input-height))}.p5address__hidden-required{pointer-events:none;position:absolute;top:0;left:0;right:0;opacity:0}.p5address__actions{position:absolute;top:0;right:0;height:var(--p5address-input-height,var(--default-p5address-input-height));min-width:var(--p5address-input-height,var(--default-p5address-input-height));z-index:5;display:flex;align-items:center;justify-content:flex-end}.p5address__actions>*{cursor:pointer;height:var(--p5address-input-height,var(--default-p5address-input-height));width:calc(.8 * var(--p5address-input-height,var(--default-p5address-input-height)));display:flex;justify-content:center;align-items:center}.p5address__actions svg{fill:var(--p5address-secondary,var(--default-p5address-secondary));transition:fill .3s ease;width:70%;height:60%}.p5address__actions>:hover svg{fill:var(--p5address-primary,var(--default-p5address-primary))}.p5address__actions .-is-open svg{transform:scaleY(-1)}.p5address__errors{text-align:left;color:var(--p5address-secondary,var(--default-p5address-secondary))}.p5address fieldset{border:0;padding:0;margin:0;position:relative;flex:1 1 auto;margin-bottom:var(--p5address-margin,var(--default-p5address-margin))}.p5address label{color:var(--p5address-secondary,var(--default-p5address-secondary));display:flex}.p5address input{width:100%;display:block;transition:all .3s ease}.p5address input.-is-invalid:not(:focus){background-color:var(--p5address-danger-bg,var(--default-p5address-danger-bg))}.p5address__parts{margin-top:var(--p5address-margin,var(--default-p5address-margin))}.p5address__parts div{display:flex}.p5address__parts div fieldset:nth-child(n+2){margin-left:var(--p5address-margin,var(--default-p5address-margin))}.opacity-50{opacity:.5}.hover\\:opacity-100:hover{opacity:1}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  

  
  var Address = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    browser,
    undefined
  );

var addressPlugin = {
  install: function install(Vue, _ref) {
    var _ref$libraries = _ref.libraries,
        libraries = _ref$libraries === void 0 ? ['places'] : _ref$libraries,
        _ref$fields = _ref.fields,
        fields = _ref$fields === void 0 ? ['address_components', 'formatted_address', 'geometry', 'place_id'] : _ref$fields,
        _ref$types = _ref.types,
        types = _ref$types === void 0 ? [] : _ref$types,
        key = _ref.key,
        client = _ref.client,
        _ref$version = _ref.version,
        version = _ref$version === void 0 ? '3' : _ref$version,
        _ref$loadGoogleApi = _ref.loadGoogleApi,
        loadGoogleApi = _ref$loadGoogleApi === void 0 ? true : _ref$loadGoogleApi;

    if (addressPlugin.installed) {
      return false;
    }

    Vue.component('GMapsAddress', Address);

    Vue.prototype.$loadGoogleMaps = function (fn) {
      if (!loadGoogleApi) {
        if (window.google) {
          fn(window.google.maps ? window.google.maps : window.google, {
            fields: fields,
            types: types
          });
        }
      } else if (window.google) {
        Vue.google = window.google;
        Vue.prototype.$google = window.google;
        fn(window.google, {
          fields: fields,
          types: types
        });
      } else if (Vue.google) {
        fn(Vue.google, {
          fields: fields,
          types: types
        });
      } else {
        loadGoogleMapsAPI({
          key: key,
          client: client,
          libraries: libraries,
          v: version
        }).then(function (google) {
          Vue.google = google;
          Vue.prototype.$google = google;
          fn(google, {
            fields: fields,
            types: types
          });
        });
      }
    };

    return true;
  }
};

export default addressPlugin;
